import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(3)
  },
  content: {
    marginBottom: theme.spacing(3),
    minHeight: 200
  },
  buttons: {
    marginTop: theme.spacing(2)
  }
}));

export default useStyles;
